const httpMethods = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
  MULTIPART: "MULTIPART",
  MULTIPART_PUT: "MULTIPART_PUT",
};

export default httpMethods;